import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useRef, useState, useEffect } from "react";
import { useTheme } from "styled-components";
// styles
import { CarouselWrapper, CustomButtonWrapper, } from "./heroimagecarousel.styles";
import { StyledScrollIndicatorWrapper, IconText, HighlightScrollIndicatorWrapper } from "./heroimage.styles";
// components
import { Carousel } from "../carousel";
import { Button } from "../button";
import { Icon } from "../icon";
// utils
import { makeDataTestIdGetter } from "../utils";
export function HeroImageCarousel({ children, items, autoslide = true, loop = true, slidingInterval = 6, dataTestIdPrefix, onChange, onScrollIconClick, }) {
    const theme = useTheme();
    const [activeColor, setActiveColor] = useState();
    const iconTextRef = useRef(null);
    const [indicatorWidth, setIndicatorWidth] = useState();
    const getDataTestId = makeDataTestIdGetter(dataTestIdPrefix);
    useEffect(() => {
        if (iconTextRef.current) {
            setIndicatorWidth(iconTextRef.current.clientWidth);
            iconTextRef.current.textContent = items[0].scrollIndicatorText;
        }
    }, [iconTextRef.current]);
    function onCarouselChange(slideIndex) {
        setActiveColor(items[slideIndex].color);
        if (iconTextRef.current)
            iconTextRef.current.textContent = items[slideIndex].scrollIndicatorText;
        if (onChange) {
            onChange(slideIndex);
        }
    }
    return (_jsxs(CarouselWrapper, { children: [_jsx(Carousel, Object.assign({ autoSnap: true, autoSliding: autoslide, loop: loop, slidingInterval: slidingInterval, responsiveLayout: {
                    small: { slides: 1, slidesToMove: 1 },
                    medium: { slides: 1, slidesToMove: 1 },
                    large: { slides: 1, slidesToMove: 1 },
                }, onChange: onCarouselChange, slideMargin: 0, nextEl: ".carousel-right-button", prevEl: ".carousel-left-button" }, { children: children })), _jsxs(CustomButtonWrapper, Object.assign({ color: activeColor }, { children: [_jsx(Button, { stylingType: "secondary", rounded: true, symbol: "chevron_left", isIcon: true, className: "carousel-left-button", "data-testid": getDataTestId("heroimage-carousel-button-left") }), _jsx(Button, { stylingType: "secondary", rounded: true, symbol: "chevron_right", isIcon: true, className: "carousel-right-button", "data-testid": getDataTestId("heroimage-carousel-button-right") })] })), _jsx(StyledScrollIndicatorWrapper, Object.assign({ animation: true }, { children: _jsxs(HighlightScrollIndicatorWrapper, Object.assign({ color: activeColor, onClick: onScrollIconClick }, { children: [_jsx(IconText, { ref: iconTextRef, color: activeColor, animation: true, alignment: indicatorWidth > 72 ? "flex-end" : "center" }), _jsx(Icon, { symbol: "double_chevron_down", color: activeColor === "white" ? theme.colors.black : theme.colors.white })] })) }))] }));
}
